import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=73fb8a90&scoped=true&lang=html"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb8a90",
  null
  
)

export default component.exports